module.exports = __webpack_public_path__ + "static/media/goblin_sword.745e724c.png";